import { AccredibleTruncateHelper } from '@accredible-frontend-v2/utils/truncate-helper';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(value: string, maxCharacters: number, customTrail?: string): string {
    return AccredibleTruncateHelper.truncate(value, maxCharacters, customTrail);
  }
}
